import { movies as movieData } from "@/mocks/movies";
import { tvShows as tvData } from "@/mocks/tvShows";
import type { VideoItem } from "@/types/video";

export const movies: VideoItem[] = movieData;
export const tvShows: VideoItem[] = tvData;
export const allVideos: VideoItem[] = [...movies, ...tvShows];

export function getVideoById(id: string): VideoItem | undefined {
  return allVideos.find((item) => item.id === id);
}

export function getFeatured(limit = 4): VideoItem[] {
  const featured = allVideos.filter((item) => item.featured);
  return featured.slice(0, limit);
}

export function getLatest(limit = 12): VideoItem[] {
  return [...allVideos]
    .sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1))
    .slice(0, limit);
}

export function getHot(limit = 8): VideoItem[] {
  return [...allVideos].sort((a, b) => b.playCount - a.playCount).slice(0, limit);
}

export function getRelated(current: VideoItem, limit = 6): VideoItem[] {
  return allVideos
    .filter((item) => item.id !== current.id)
    .map((item) => {
      const overlap = item.genres.filter((g) => current.genres.includes(g)).length;
      return { item, overlap };
    })
    .sort((a, b) => {
      if (b.overlap !== a.overlap) return b.overlap - a.overlap;
      return b.item.rating - a.item.rating;
    })
    .slice(0, limit)
    .map((entry) => entry.item);
}

export function searchVideos(keyword: string): VideoItem[] {
  const key = keyword.trim().toLowerCase();
  if (!key) return [];
  return allVideos.filter((item) => {
    const inTitle = item.title.toLowerCase().includes(key);
    const inActors = item.actors.some((actor) => actor.toLowerCase().includes(key));
    const inDirector = item.director.toLowerCase().includes(key);
    const inGenres = item.genres.some((g) => g.toLowerCase().includes(key));
    return inTitle || inActors || inDirector || inGenres;
  });
}

export function formatPlayCount(count: number): string {
  if (count >= 100000000) return `${(count / 100000000).toFixed(1)}亿`;
  if (count >= 10000) return `${(count / 10000).toFixed(1)}万`;
  return `${count}`;
}